import { useMemo } from "react";

import { DELETABLE_EMAIL_TYPES, EmailContentType, Emptyable } from "@simplyk/common";

import { useTranslate } from "@/hooks/useTranslate";

export const useRecipientPlaceholder = ({
  emailType,
  campaignName,
  hasRecipients = false,
}: {
  emailType?: Emptyable<EmailContentType>;
  campaignName?: string;
  hasRecipients?: boolean;
}) => {
  const { t } = useTranslate();

  const campaignInfo = campaignName ? ` ${t("dashboard", "EmailDrawer.recipientEmails.on")} ${campaignName}` : "";

  const recipientPlaceholderMap = useMemo(
    () => ({
      [EmailContentType.REMINDER]: t("dashboard", "EmailDrawer.recipientEmails.eventGuests"),
      [EmailContentType.POST_EVENT]: t("dashboard", "EmailDrawer.recipientEmails.eventGuests"),
      [EmailContentType.FOLLOW_UP]: t("dashboard", "EmailDrawer.recipientEmails.eventFollowup"),
      [EmailContentType.BLAST]: hasRecipients
        ? undefined
        : `${t("dashboard", "EmailDrawer.recipientEmails.eventBlast")}${campaignInfo}`,
      [EmailContentType.INVITATION]: undefined,
    }),
    [t, campaignInfo, hasRecipients]
  );

  return emailType ? recipientPlaceholderMap[emailType] : undefined;
};

export const useIsPlaceholderDeletable = (emailType: Emptyable<EmailContentType>) => {
  return emailType ? DELETABLE_EMAIL_TYPES.includes(emailType) : false;
};
